"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TablePaginator = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../Icons/PetSure/Icon");
var _TableProps = require("../TableProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TablePaginator = _ref => {
  let {
    tableInstance,
    totalNumberRows,
    showSkipButtons = true,
    showCurrentPageDetails = true,
    showPageInputField = true,
    showPageSizeField = true
  } = _ref;
  const {
    gotoPage,
    canPreviousPage,
    previousPage,
    nextPage,
    canNextPage,
    pageCount,
    pageOptions,
    pageIndex,
    pageSize,
    setPageSize,
    initialState
  } = tableInstance;
  const PAGE_SIZES = [10, 20, 30, 40, 50, 100, 'all'];

  // Don't render the paginator if all the rows are showing
  if (initialState.pageSize >= totalNumberRows || pageSize >= totalNumberRows) {
    return null;
  }
  const HandlePageSizeChange = newPageSize => {
    if (newPageSize === 'all') {
      return setPageSize(totalNumberRows);
    }
    return setPageSize(Number(newPageSize));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pagination"
  }, showSkipButtons && /*#__PURE__*/_react.default.createElement("div", {
    className: "pagination_skipButtons"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "button icon_only",
    "aria-label": "Go to first page",
    type: "button",
    onClick: () => gotoPage(0),
    disabled: !canPreviousPage
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "caret_left"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "caret_left"
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: "button icon_only",
    "aria-label": "Go to previous page",
    type: "button",
    onClick: () => previousPage(),
    disabled: !canPreviousPage
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "caret_left"
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: "button icon_only",
    "aria-label": "Go to next page",
    type: "button",
    onClick: () => nextPage(),
    disabled: !canNextPage
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "caret_right"
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: "button icon_only",
    "aria-label": "Go to last page",
    type: "button",
    onClick: () => gotoPage(pageCount - 1),
    disabled: !canNextPage
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "caret_right"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "caret_right"
  }))), showCurrentPageDetails && /*#__PURE__*/_react.default.createElement("span", {
    className: "currentPageDetails"
  }, "Page\xA0", /*#__PURE__*/_react.default.createElement("strong", null, pageIndex ? pageIndex + 1 : 1, " of ", pageOptions.length), ' '), showPageInputField && /*#__PURE__*/_react.default.createElement("span", {
    className: "pageInputField"
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "labelText"
  }, "Go to page"), /*#__PURE__*/_react.default.createElement("input", {
    id: "".concat(tableInstance.id, "_tablePaginatorPageInputField"),
    type: "number",
    defaultValue: pageIndex ? pageIndex + 1 : 1,
    onChange: e => {
      const page = e.target.value ? Number(e.target.value) - 1 : 0;
      gotoPage(page);
    }
  }))), showPageSizeField && /*#__PURE__*/_react.default.createElement("span", {
    className: "pageSizeField"
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Set how many records to show at a time."), /*#__PURE__*/_react.default.createElement("select", {
    id: "".concat(tableInstance.id, "_tablePaginatorPageSizeField"),
    value: pageSize,
    onChange: e => {
      HandlePageSizeChange(e.target.value);
    }
  }, PAGE_SIZES.map(pageSize => /*#__PURE__*/_react.default.createElement("option", {
    key: pageSize,
    value: pageSize
  }, "Show ", pageSize))))));
};
exports.TablePaginator = TablePaginator;
TablePaginator.propTypes = {
  tableInstance: _propTypes.default.shape(_TableProps.TableStateProps),
  totalNumberRows: _propTypes.default.number.isRequired,
  showSkipButtons: _propTypes.default.bool,
  showCurrentPageDetails: _propTypes.default.bool,
  showPageInputField: _propTypes.default.bool,
  showPageSizeField: _propTypes.default.bool
};